export default __webpack_public_path__ + "static/lifehack-2021-champion-7c870ffa65a7e7c203159164c50aaae9.jpg";